import LibrarySelect from "./library-select";
import LibrarySelectModal from "./library-select-modal";
export { LibrarySelect };
export default {
  Component: LibrarySelect,
  Modal: LibrarySelectModal
};
//# sourceMappingURL=index.js.map